export default __webpack_public_path__ + "ce8348d50a3156c2e313ddf7a59e1256.webp";